<template>
  <div class="underway">
    <h3 class="tit">正在进行中的订单</h3>
    <div class="noNumber" v-if="count === '0' || !count">暂无数据</div>
    <el-row :gutter="20">
      <el-col :span="8" v-for="item in list" :key="item.id">
        <div class="item border radius">
          <div class="text">
            <p class="title ellipsis">{{item.task_title}}</p>
            <p class="det c999">
              <span>赏金金额：￥{{item.money}}</span>
              <span>点击量：{{item.task_click}}</span>
            </p>
            <p class="time c999">结束时间：{{item.task_time}}</p>
          </div>
          <div class="fot">
            <span class="surplus">已完成点击量：{{item.click_num}}</span>
            <el-button type="primary" size="mini" plain class="btn" @click="viewOrder(item.id,item.task_id,item.user_id)">查看数据</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'Underway',
  props: {
    list: Array,
    count: String
  },
  methods: {
    viewOrder(id,task_id,user_id){
      this.$router.push({path:'/daren/detail'+'?id=' + id + '&task_id=' + task_id + '&user_id=' + user_id})
    }
  }
}
</script>
<style scoped>
  .underway .tit{font-size:16px;font-weight:normal;margin-bottom: 20px;}
  .underway .item .text{padding:10px 20px;line-height:30px;}
  .underway .item .text .title{font-size:14px;}
  .underway .item .text .det span{margin-right:10px;}
  .underway .item .fot{background: #f8f8f8;border-top:1px #eee solid;height:46px;line-height:46px;padding:0 20px;position: relative;}
  .underway .item .fot .btn{position: absolute;right:20px;top:8px;}
</style>
